import React from 'react';
const EmbeddedContext = React.createContext(null);
export const EmbeddedProvider = EmbeddedContext.Provider;
export default EmbeddedContext;
